import { FormHelperText, Grid, TextField, Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import { useTheme } from "@material-ui/styles";
import {
  StyledTableCell,
  TableRowHead,
  useStyles,
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash-es";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

export default function VisaTerminationSection({ formik, colSpan = 3 }) {
  const theme = useTheme();
  const classes = useStyles();
  const masterData = useSelector(selectMasterData);
  const terminationSmartTypeConfig = get(
    masterData,
    "terminationSmartTypeConfig",
    []
  );

  const canEdit = useSelector(canEditForm);

  const isDepartFlight =
    formik.values.document?.termination ===
    "888f7be4-a767-4257-ba2d-8a37c81ef005";
  const isResumeWork =
    formik.values.document?.termination ===
    "f6c5f77f-97d8-463e-974a-d10f92ae3854";

  useEffect(() => {
    if (isDepartFlight) {
      formik.setFieldValue("document.ResumeWork", "");
    }
    if (isResumeWork) {
      formik.setFieldValue("document.Flight", "");
      formik.setFieldValue("document.FlightDate", null);
    }
  }, [isDepartFlight, isResumeWork]);

  return (
    <TableBody style={{ width: "100%" }}>
      <TableRowHead>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <Typography variant="h6" className={classes.tableTitle}>
                Details of Visa Termination
              </Typography>
            </div>
          </div>
        </StyledTableCell>
      </TableRowHead>

      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <Grid container spacing={1} style={{ padding: "12px 24px" }}>
            <Grid item xs={12} md={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel className={classes.formControl}>
                    Desired date of Visa termination (dd-mm-yyyy)
                  </InputLabel>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <DatePicker
                    disabled={!canEdit}
                    className={classes.formControl}
                    inputVariant="outlined"
                    disableFuture={false}
                    openTo="year"
                    format="DD-MM-YYYY"
                    label="(dd-mm-yyyy)"
                    views={["year", "month", "date"]}
                    value={formik.values.document?.ValidUntil || null}
                    onChange={(date) => {
                      formik.setFieldValue(
                        `document.ValidUntil`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError(`document.ValidUntil`, formik)}
                    helperText={getErrorMessage(`document.ValidUntil`, formik)}
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <Grid container spacing={1} style={{ padding: "12px 24px" }}>
            <Grid item xs={12} md={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel className={classes.formControl}>
                    Travel out of the country by
                  </InputLabel>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    error={isError("document.termination", formik)}
                  >
                    <InputLabel>Selected Travel out of the country </InputLabel>
                    <Select
                      disabled={!canEdit}
                      label="Selected Travel out of the country "
                      name="document.termination"
                      value={formik.values.document?.termination}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      {terminationSmartTypeConfig.map((item) => (
                        <MenuItem
                          value={item.terminationSmartTypeID}
                          key={item.terminationSmartTypeID}
                        >
                          {item.terminationSmartTypeName}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText
                      error={isError("document.termination", formik)}
                    >
                      {getErrorMessage("document.termination", formik)}
                    </FormHelperText>
                  </FormControl>
                </div>
              </div>
            </Grid>

            {isResumeWork && (
              <>
                <Grid item xs={12} md={3} />
                <Grid item xs={12} md={3}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <InputLabel className={classes.formControl}>
                        Company
                      </InputLabel>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <TextField
                        disabled={!canEdit}
                        className={classes.formControl}
                        variant="outlined"
                        label="Company"
                        name="document.ResumeWork"
                        value={formik.values.document?.ResumeWork}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.ResumeWork", formik)}
                        helperText={getErrorMessage(
                          "document.ResumeWork",
                          formik
                        )}
                      />
                    </div>
                  </div>
                </Grid>
              </>
            )}

            {isDepartFlight && (
              <>
                <Grid item xs={12} md={3} />
                <Grid
                  item
                  xs={12}
                  md={1}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    paddingTop: theme.spacing(4),
                  }}
                >
                  <InputLabel> Flight No.</InputLabel>
                </Grid>
                <Grid item xs={12} md={5}>
                  <div className={classes.cellContent}>
                    <div className={classes.wrapField}>
                      <TextField
                        disabled={!canEdit}
                        className={classes.formControl}
                        variant="outlined"
                        name="document.Flight"
                        value={formik.values.document?.Flight}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={isError("document.Flight", formik)}
                        helperText={getErrorMessage("document.Flight", formik)}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={1}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    paddingTop: theme.spacing(4),
                  }}
                >
                  <InputLabel>Date</InputLabel>
                </Grid>
                <Grid item xs={12} md={5}>
                  <DatePicker
                    disabled={!canEdit}
                    className={classes.formControl}
                    inputVariant="outlined"
                    disableFuture={false}
                    openTo="year"
                    format="DD-MM-YYYY"
                    label="(dd-mm-yyyy)"
                    views={["year", "month", "date"]}
                    value={formik.values.document?.FlightDate || null}
                    onChange={(date) => {
                      formik.setFieldValue(
                        `document.FlightDate`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError(`document.FlightDate`, formik)}
                    helperText={getErrorMessage(`document.FlightDate`, formik)}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </StyledTableCell>
      </TableRow>

      <div />
    </TableBody>
  );
}
